import { FC } from 'react';
import { Box, BoxProps, Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

interface GraphLegendProps extends BoxProps {
  label: string;
}

const GraphLegend: FC<GraphLegendProps> = ({
  backgroundColor,
  borderColor,
  borderRadius = 'radius-2',
  borderWidth = 1,
  label,
  ...props
}) => (
  <Flex alignItems="center">
    <Box
      backgroundColor={backgroundColor}
      border={`${borderWidth}px solid`}
      borderColor={borderColor ?? backgroundColor}
      borderRadius={borderRadius}
      boxSize="8"
      {...props}
    />
    <Text marginLeft="space-8" size="sm">
      {label}
    </Text>
  </Flex>
);

export default GraphLegend;
